<template>
  <div>
    <header class="header-main_v2">
      <nav class="mobile-menu">
        <div class="menu_v2_contains">
          <div class="logo">
            <router-link to="/home" :class="['logo-header', getActiveTabClass('/home')]">
              <img :src="getTranslations.project_logo_img" alt="">
            </router-link>
          </div>
          <button data-menu="dropdown_lang" class="nav__toggle nav__toggle_lang"></button>
          <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
          <div class="items">
            <a style="cursor:pointer" @click.prevent=goToNotifications>
              <img src="static/images/icon-notifications.svg">
            </a>
            <nav class="main-nav">
              <ul v-if="!hideLangSelection" class="main-nav__lang" id="get_started_menu">
                <li class="dropdown">
                  <a><div class="icon-globe"><img src="static/images/icon-globe.svg" alt=""></div></a>
                  <ul>
                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <input type="checkbox" id="checkbox" class="mobile-menu__checkbox">
        <label for="checkbox" class="mobile-menu__btn">
          <div :class="['mobile-menu__icon', burgerButtonClicked ? 'open' : '']" @click.prevent="burgerButtonClicked = !burgerButtonClicked">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </label>
        <div :class="['mobile-menu__container', burgerButtonClicked ? 'open' : '']">
          <ul class="mobile-menu__list">
            <li v-if="!hideStore" class="mobile-menu__item">
              <router-link to="/home/store" :class="['mobile-menu__link', getActiveTabClass('/home/store')]">
                {{ getTranslations.home_home_store }}
              </router-link>
            </li>
            <li class="mobile-menu__item">
              <router-link to="/home/profile" :class="['mobile-menu__link', getActiveTabClass('home/profile')]">
                {{ getTranslations.home_home_profile }}
              </router-link>
            </li>
            <li v-if="!hideWinners" class="mobile-menu__item"> <!-- WINNERS -->
              <router-link to="/home/winners" :class="['mobile-menu__link', getActiveTabClass('/home/winners')]">
                {{ getTranslations.home_home_winners }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/home/howitworksLoggedIn" :class="['mobile-menu__link', getActiveTabClass('/home/howitworksLoggedIn')]">
                {{ getTranslations.home_home_how_it_works }}
              </router-link>
            </li>
            <li class="mobile-menu__item"> <!--HOW IT WORKS -->
              <router-link to="/home/achievements" :class="['mobile-menu__link', getActiveTabClass('/home/achievements')]">
                {{ getTranslations.home_home_achievements }}
              </router-link>
            </li>
            <li class="mobile-menu__item last">
              <a @click.prevent="logoutUser" style="cursor:pointer" class="mobile-menu__link">
                {{ getTranslations.home_home_log_out }}</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <router-view :playGame="playGameMethod"></router-view>
    <fade-transition>
      <component :is="currentModal"
                 @close="closeHomeModal(true)"/>
    </fade-transition>
    <fade-transition>
      <component :is="modalForHomePage" v-bind="currentProperties" @close="closeHomeModal(false)"
                 @openNewModal="openNewModal($event)"></component>
    </fade-transition>


  </div>
</template>


<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import { handleLanguageDropdown, openCloseTab } from '@/common/jQuery';
import { listenForPushNotifications } from '@/common/serviceWorkers';
import FadeTransition from '@/components/home/sharedcomponents/FadeTransition';
import NewGameMixin from '@/common/mixins/home';
import IntegrationMixin from '@/common/mixins/integration';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';
import BonusDaily from './modals/bonus_phases/BonusDaily';
import SpinWheelPrize from './modals/spinwheel/SpinWheelPrize';
import HomeScreenShortcut from './modals/HomeScreenShortcut';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  mixins: [NewGameMixin, IntegrationMixin],
  components: { FadeTransition },
  data() {
    return {
      currentModal: null,
      prizeModalName: null,
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      isIos: false,
      currentTabPath: null,
      showedModal: false,
      burgerButtonClicked: false,
      homeScreenModalApplied: null,
      homeScreenModalDenied: null,
      homeScreenModalEnable: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path.includes('/home')) {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    this.currentModal = null;
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    openCloseTab();
    this.burgerButtonClicked = false;
    next();
  },
  created() {
    listenForPushNotifications();
    this.currentTabPath = sessionStorage.getItem('homeCurrentTabPath');
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserAchievements();
    this.loadManifest();
    this.homeScreenModalApplied = localStorage.getItem('homeScreenModalApplied');
    this.homeScreenModalDenied = sessionStorage.getItem('homeScreenModalDenied');
    if (this.homeScreenModalApplied || this.homeScreenModalDenied || this.userDetails.hasPhoneShortcut) this.storeHomeScreenModalDisable(true);
    this.getBonusPhases().then(() => {
      this.getUserNotifications().then(() => {
        // example url for extra Notifications from SocketJS -- http://localhost:8181/api/sendNotifications?msisdn=300136987410
        this.stompClient = webSocket.getNotificationsStompClient();
        if (this.stompClient === null) {
          this.stompClient = webSocket.createNewStompClient('/notificationsData');
        }
        this.connect();
        if (this.bonusDailyModal) {
          if (this.phoneShortcutEnabled && this.shortCutModalEnable()) {
            if (this.firstTimeEntry) {
              this.storeModalForHomePage(HomeScreenShortcut);
              this.showModal().then(() => {
                console.log('hr8eee');
                this.setFirstTimeEntry(true);
                this.methodForPopUps();
              });
            } else {
              this.storeModalForHomePage(HomeScreenShortcut);
              this.showModal();
            }
          } else {
            this.storeModalForHomePage(BonusDaily);
          }
        }
      });
    });

  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleLanguageDropdown(this);
    });
    this.autoCheckIfGameToResumeExists();
    console.log('EVENT AFTER THIS:', this.getInstallPromptEvent);
    openCloseTab();
    this.burgerButtonClicked = false;
  },
  updated() {
    // eslint-disable-next-line
    console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
      + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
      + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
        && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeHomeScreenModalDisable',
      'setInstallPromptEvent',
    ]),
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    ...mapMutations('game', [
      'resetPrizePostGameData',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
      'awardPrizeAction',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
      'getUserAchievements',
      'getUserNotifications',
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
      'getBonusPhases',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    playGameMethod() {
      this.playGame();
    },
    closeHomeModal(isCurrentModal) {
      if (isCurrentModal) this.currentModal = null; else this.storeModalForHomePage(null);
      if (!this.currentModal && !this.modalForHomePage) {
        /* eslint-disable */
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        /* eslint-enable */
      } else {
        this.showModal();
      }
    },
    loadManifest() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const link = document.createElement('link');
        link.rel = 'manifest';
        link.crossOrigin = 'anonymous';
        const data = this.getTranslations.home_manifest_file_path ? this.getTranslations.home_manifest_file_path : 'static/manifest/manifest.json';
        link.href = data; // Update the path accordingly
        console.log('MANIFEST PATH: ', data);
        document.head.appendChild(link);
      }
    },
    beforeInstallPromptHandler(event) {
      event.preventDefault();
      // Store the event to prompt the user later
      console.log('EVENT', event);
      sessionStorage.setItem('shortCutEvent', event);
      this.setInstallPromptEvent(event);
    },
    /* eslint-disable */
    shortCutModalEnable() {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        // The PWA is installed
        console.log('PWA is installed');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        console.log('not a mobile');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (this.phoneShortcutEnabled) return this.homeScreenModalApplied === 'true' ? false : this.homeScreenModalDenied !== 'true';
      this.storeHomeScreenModalDisable(true);
      return false;
    },
    openNewModal(event) {
      this.storeModalForHomePage(null);
      this.prizeModalName = event;
      this.storeModalForHomePage(SpinWheelPrize);
      this.showModal();
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
          const vm = this;
          this.$nextTick(() => {
            /* eslint-disable */
            // open modal
            $('.modal,.modal-overlay,.overlay').fadeIn(200);
            $("body").addClass("modal-open");
            // hide modal
            $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
              $(".popup_box").fadeOut(200);
              $(".overlay").fadeOut(200);
              $('.modal, .modal-overlay').fadeOut();
              $("body").removeClass("modal-open");
              /* eslint-enable */
              vm.storeModalForHomePage(null);
            });
          });
        } else {
          this.methodForPopUps();
        }
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.currentModal = WelcomeSignup;
        this.showModal();
      } else {
        if (this.unauthorizedWinnerInfo.existPrize) {
          if (this.unauthorizedWinnerInfo.msisdn === this.userDetails.msisdn) { // case where he wins a prize and login with a different user
            this.storeModalForHomePage(PrizeForFreeGame);
            this.awardPrizeAction();
            this.showModal();
          } else {
            this.resetPrizePostGameData();
          }
        } else {
          const nowDate = new Date(moment().format('L'));
          const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
          if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableGames === 0 && this.userDetails.subscribed) && (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
            this.storeModalForHomePage(ZeroBalance);
            this.showModal();
            sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
          }
          if (!this.userDetails.subscribed && (!this.bonusDailyModal) && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForHomePage(ResubscribeGameSms);
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
            this.showModal();
          }
        }
        console.log(this.homeScreenModalDisable);
        console.log('this.homeScreenModalDisable');

        if (this.shortCutModalEnable() && !this.homeScreenModalDisable && this.userDetails.subscribed && (!this.bonusDailyModal) && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
          this.storeModalForHomePage(HomeScreenShortcut);
          this.showModal();
        }
      }
    },
    connect() {
      this.stompClient.connect({ Authorization: auth.getJwt() }, this.stompSuccess, this.stompFailure);
    },
    stompSuccess(frame) {
      clearTimeout(this.connectionTimer);
      // eslint-disable-next-line
      console.log(`In Home component: ${frame}`);
      console.log(`Inside Created ${this.userDetails.msisdn}`);
      console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
      this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
        console.log('==> Inside notification response');
        const notificationsDTO = JSON.parse(response.body);
        this.storeNotificationsFromSocket({ notifications: notificationsDTO });
        console.log('notificationsDTO');
        console.log(notificationsDTO);
      }, (errorResponse) => { // error callback
        console.log('errorResponse');
        console.log(errorResponse);
      });
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          if (this.firstTimeEntry) {
            this.setFirstTimeEntry(false);
            this.currentModal = null;
            this.methodForPopUps();
          } else {
            if (!this.showedModal) {
              console.log("----------------------- Correct Exit For  Store showHideModal");
              this.resetPrizePostGameData();
              this.showedModal = true;
              this.storeModalForHomePage(null);
            } else {
              this.storeModalForHomePage(null);
            }
          }
        });
      });
      /* eslint-enable */
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.updateUserLanguage().then(() => {
          this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
            this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
              this.facebookSDKApi().then(() => {
                this.changeCSSFile();
              });
            });
          });
        });
      });
    },
    stompFailure(error) {
      // console.clear();
      console.log(error);
      console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
      clearTimeout(this.connectionTimer);
      this.connectionTimer = setTimeout(() => {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
        this.connect();
      }, 3000);
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    goToNotifications() {
      this.$router.push('/home/notifications');
    },
    logoutUser() {
      this.closeAllStompClients();
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null) currentLocale = this.getLocale;
      const soundsOn = localStorage.getItem('soundsOn');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0) sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      this.clearAllData();
      window.location.reload();
      this.$router.push('/');
    },
    closeAllStompClients() {
      if (this.subscription) this.subscription.unsubscribe();
      webSocket.disconnectStompClient(this.stompClient);
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
      'hideLangSelection',
      'hideWinners',
      'hideLeaderboard',
      'userDetails',
      'modalForHomePage',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'facebookFunctionality',
      'multiOperatorInfo',
      'phoneShortcutEnabled',
      'homeScreenModalDisable',
    ]),
    ...mapGetters('common', [
      'getInstallPromptEvent',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'unauthorizedWinnerInfo',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'firstTimeEntry',
      'notifications',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
    ]),
    ...mapState('i18n', [
      'availableLocales',
    ]),
    currentProperties() {
      if (this.modalForHomePage === SpinWheelPrize) {
        return {
          prizeInfo: {
            prizeName: this.prizeModalName,
          },
        };
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue